const APPROVAL_GLYPH = 'gem-thumbs-up'
const ERROR_GLYPH = 'gem-error-circle'
const TASK_GLYPH = 'checkmark-sm'

export { APPROVAL_GLYPH, ERROR_GLYPH, TASK_GLYPH }
